import React, { useState } from 'react';
import DraftPlayerConfig from './DraftPlayerConfig';
import DraftBoard from './DraftBoard';

const DraftPlayerV2 = () => {
  const [view, setView] = useState('config');

  if (view === 'board') {
    return <DraftBoard onCancel={() => setView('config')} />;
  }

  return <DraftPlayerConfig onShowBoard={() => setView('board')} />;
};

export default DraftPlayerV2;
